import { Box, Card, CardBody, Center, Flex, Heading, Link, Spinner, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { useListMyContributionsQuery } from "../../../../autogen/bff-api";
import { useReportQueryError } from "../../../../common/errors/useReportQueryError";
import { PortalLayout } from "../components/PortalLayout";
import { useContributionUrls } from "./useContributionUrls";
import { ContributingEntityStatusTag } from "../bid/contributing/ContributingEntityStatusTag";

export const SupplierContributionsList = () => {
  const { t } = useTranslation();
  const urls = useContributionUrls();
  const { data, isLoading, error } = useListMyContributionsQuery({});

  useReportQueryError(error);

  const items = data?.items ?? [];

  return (
    <PortalLayout>
        <Box>
        <Heading size="md" mb="2">
          {t("My contributions")}
        </Heading>
        <Text fontSize="sm" color="smMuted" mb="6">
          {t("Offers where another supplier has named your company as a participant.")}
        </Text>

        {isLoading && (
          <Center py="12">
            <Spinner color="smPrimary" />
          </Center>
        )}

        {!isLoading && items.length === 0 && (
          <Text fontSize="sm" color="smMuted">
            {t("No one has invited your company to contribute to an offer yet.")}
          </Text>
        )}

        <Stack spacing="3">
          {items.map((item) => (
            <Card key={item.entity.id} variant="outline" rounded="xl">
              <CardBody>
                <Flex justify="space-between" align="flex-start" gap="4" flexWrap="wrap">
                  <Box>
                    <Link as={RouterLink} to={urls.view(item.entity.id)} color="smPrimary" fontWeight="semibold">
                      {item.context.eventTitle}
                    </Link>
                    <Text fontSize="sm" color="smMuted">
                      {t("Invited by {{leadSupplier}}", { leadSupplier: item.context.leadSupplierName })}
                    </Text>
                  </Box>
                  <ContributingEntityStatusTag status={item.entity.status} />
                </Flex>
              </CardBody>
            </Card>
          ))}
        </Stack>
      </Box>
    </PortalLayout>
  );
};
